import { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { http } from "@/api";
import { useStore } from "@/context/StoreContext";
import { Button } from "@/components/ui/button";

export function useSettingsDraft() {
  const { settings, reloadSettings } = useStore();
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);
  const base = useRef("");
  useEffect(() => {
    if (!settings) return;
    const json = JSON.stringify(settings);
    if (!d || JSON.stringify(d) === base.current) setD(JSON.parse(json));
    base.current = json;
  }, [settings]); // eslint-disable-line
  const dirty = useMemo(() => d && settings && JSON.stringify(d) !== JSON.stringify(settings), [d, settings]);
  const set = (k, v) => setD((x) => ({ ...x, [k]: v }));
  const setIn = (k, sub, v) => setD((x) => ({ ...x, [k]: { ...(x[k] || {}), [sub]: v } }));
  async function save() {
    setSaving(true);
    try {
      const { _id, id, key, updated_at, ...rest } = d;
      await http.put("/settings", rest);
      await reloadSettings();
      toast.success("Cambios guardados y publicados");
    } catch { toast.error("Error al guardar"); } finally { setSaving(false); }
  }
  const SaveBtn = (
    <Button className="btn-primary" onClick={save} disabled={!dirty || saving} data-testid="settings-save">
      <Save size={14} className="mr-1" /> {saving ? "Guardando…" : dirty ? "Guardar cambios" : "Guardado"}
    </Button>
  );
  return { d, set, setIn, SaveBtn, dirty };
}
